export default __webpack_public_path__ + "static/media/trr-food-handheld-tunasaladwrap.17f9a83d.png";